export function shouldShowFreebetTag(props: {
    isFreebet?: boolean;
    transactionTypeAbrv?: string;
    amount?: number;
}) {

    if (props.transactionTypeAbrv !== undefined && props.isFreebet !== undefined) {
        return (
            props.transactionTypeAbrv === "bet-slip-payment-bonus" &&
            props.isFreebet
        );
    }

    if (props.isFreebet !== undefined) {
        return props.isFreebet;
    }

    return (
        props.transactionTypeAbrv === "bet-slip-payment-bonus" &&
        props.amount === 0
    );
}